module.exports = __webpack_public_path__ + "static/media/round-timer-08.29a9eea5.svg";